// import { useState } from "react";
// import { Box, Button, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from "@mui/material";
// import { DataGrid, GridToolbar } from "@mui/x-data-grid";
// import { tokens } from "../../theme";
// import { mockDataContacts } from "../../data/mockData"; // Initially imported data
// import Header from "../../components/Header";
// import { useTheme } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import VisibilityIcon from "@mui/icons-material/Visibility";

// const Contacts = () => {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);

//   // State to manage the rows
//   const [rows, setRows] = useState(mockDataContacts);
//   const [open, setOpen] = useState(false); // State to control the dialog
//   const [selectedRow, setSelectedRow] = useState(null); // State to hold selected row data

//   // Function to handle row deletion
//   const handleDelete = (id) => {
//     const updatedRows = rows.filter((row) => row.id !== id); // Filter out the row to be deleted
//     setRows(updatedRows); // Update the rows state with the filtered data
//   };

//   const handleEdit = (id) => {
//     console.log("Edit row with ID:", id);
//     // Add your edit logic here
//   };

//   // Function to handle view icon click and open popup
//   const handleView = (row) => {
//     setSelectedRow(row); // Set the clicked row data
//     setOpen(true); // Open the dialog
//   };

//   // Function to close the popup dialog
//   const handleClose = () => {
//     setOpen(false);
//     setSelectedRow(null);
//   };

//   const columns = [
//     { field: "id", headerName: "ID", flex: 0.5 },
//     { field: "registrarId", headerName: "Registrar ID" },
//     {
//       field: "name",
//       headerName: "Name",
//       flex: 1,
//       cellClassName: "name-column--cell",
//     },
//     {
//       field: "age",
//       headerName: "Age",
//       type: "number",
//       headerAlign: "left",
//       align: "left",
//     },
//     {
//       field: "phone",
//       headerName: "Phone Number",
//       flex: 1,
//     },
//     {
//       field: "email",
//       headerName: "Email",
//       flex: 1,
//     },
//     {
//       field: "address",
//       headerName: "Address",
//       flex: 1,
//     },
//     {
//       field: "city",
//       headerName: "City",
//       flex: 1,
//     },
//     {
//       field: "zipCode",
//       headerName: "Zip Code",
//       flex: 1,
//     },
//     // Edit, View, and Delete actions
//     {
//       field: "actions",
//       headerName: "Actions",
//       flex: 1,
//       sortable: false,
//       renderCell: (params) => {
//         return (
//           <Box>
//             {/* View Icon */}
//             <IconButton onClick={() => handleView(params.row)}>
//               <VisibilityIcon style={{ color: colors.greenAccent[500] }} />
//             </IconButton>

//             {/* Edit Icon */}
//             <IconButton onClick={() => handleEdit(params.row.id)}>
//               <EditIcon style={{ color: colors.blueAccent[600] }} />
//             </IconButton>

//             {/* Delete Icon */}
//             <IconButton onClick={() => handleDelete(params.row.id)}>
//               <DeleteIcon style={{ color: colors.redAccent[600] }} />
//             </IconButton>
//           </Box>
//         );
//       },
//     },
//   ];

//   return (
//     <Box m="20px">
//       <Header title="Farmer Management" subtitle="List of Farmers Details" />
//       <Box
//         m="40px 0 0 0"
//         height="75vh"
//         sx={{
//           "& .MuiDataGrid-root": {
//             border: "none",
//           },
//           "& .MuiDataGrid-cell": {
//             borderBottom: "none",
//           },
//           "& .name-column--cell": {
//             color: colors.greenAccent[300],
//           },
//           "& .MuiDataGrid-columnHeaders": {
//             backgroundColor: colors.blueAccent[700],
//             borderBottom: "none",
//           },
//           "& .MuiDataGrid-virtualScroller": {
//             backgroundColor: colors.primary[400],
//           },
//           "& .MuiDataGrid-footerContainer": {
//             borderTop: "none",
//             backgroundColor: colors.blueAccent[700],
//           },
//           "& .MuiCheckbox-root": {
//             color: `${colors.greenAccent[200]} !important`,
//           },
//           "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
//             color: `${colors.grey[100]} !important`,
//           },
//         }}
//       >
//         {/* Add Button */}
//         <Box display="flex" justifyContent="flex-end" mb={2}>
//           <Button variant="contained" color="primary" sx={{ marginTop: "20px" }}>
//             Add Farmer
//           </Button>
//         </Box>

//         <DataGrid
//           rows={rows}  // Updated to use state rows
//           columns={columns}
//           components={{ Toolbar: GridToolbar }}
//         />

//         {/* View Row Dialog */}
//         <Dialog open={open} onClose={handleClose}>
//           <DialogTitle>Farmer Management</DialogTitle>
//           <DialogContent>
//             {selectedRow && (
//               <>
//                 <Typography><strong>ID:</strong> {selectedRow.id}</Typography>
//                 <Typography><strong>Registrar ID:</strong> {selectedRow.registrarId}</Typography>
//                 <Typography><strong>Name:</strong> {selectedRow.name}</Typography>
//                 <Typography><strong>Age:</strong> {selectedRow.age}</Typography>
//                 <Typography><strong>Phone:</strong> {selectedRow.phone}</Typography>
//                 <Typography><strong>Email:</strong> {selectedRow.email}</Typography>
//                 <Typography><strong>Address:</strong> {selectedRow.address}</Typography>
//                 <Typography><strong>City:</strong> {selectedRow.city}</Typography>
//                 <Typography><strong>Zip Code:</strong> {selectedRow.zipCode}</Typography>
//               </>
//             )}
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={handleClose} color="primary">Close</Button>
//           </DialogActions>
//         </Dialog>
//       </Box>
//     </Box>
//   );
// };

// export default Contacts;



// import { useState, useEffect } from "react";
// import axios from "axios";
// import { Box, Button, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from "@mui/material";
// import { DataGrid, GridToolbar } from "@mui/x-data-grid";
// import { tokens } from "../../theme";
// import Header from "../../components/Header";
// import { useTheme } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import VisibilityIcon from "@mui/icons-material/Visibility";

// const Contacts = () => {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);

//   const [rows, setRows] = useState([]); // State to manage rows data
//   const [open, setOpen] = useState(false); // State to control the dialog
//   const [selectedRow, setSelectedRow] = useState(null); // State to hold selected row data

//   const getTransactionData = async () => {
//     try {
//       const response = await axios.get('http://localhost:3000/api/contacts');
//       console.log(response.data);
//       setRows(response.data); // Set the fetched data directly to rows
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   useEffect(() => {
//     getTransactionData();
//   }, []);

//   // Function to handle row deletion
//   const handleDelete = async (registrarId) => {
//     try {
//       await axios.delete(`http://localhost:3000/api/contacts/${registrarId}`); // Make API call to delete
//       const updatedRows = rows.filter((row) => row.registrarid !== registrarId); // Filter out the deleted row
//       setRows(updatedRows); // Update the rows state with the filtered data
//     } catch (error) {
//       console.error("Error deleting data:", error);
//     }
//   };

//   const handleEdit = (id) => {
//     console.log("Edit row with ID:", id);
//     // Add your edit logic here
//   };

//   // Function to handle view icon click and open popup
//   const handleView = (row) => {
//     setSelectedRow(row); // Set the clicked row data
//     setOpen(true); // Open the dialog
//   };

//   // Function to close the popup dialog
//   const handleClose = () => {
//     setOpen(false);
//     setSelectedRow(null);
//   };

//   const columns = [
//     { field: "id", headerName: "ID", flex: 0.5 },
//     { field: "registrarid", headerName: "Registrar ID" },
//     { field: "name", headerName: "Name", flex: 1, cellClassName: "name-column--cell" },
//     { field: "age", headerName: "Age", type: "number", headerAlign: "left", align: "left" },
//     { field: "phone", headerName: "Phone Number", flex: 1 },
//     { field: "email", headerName: "Email", flex: 1 },
//     { field: "address", headerName: "Address", flex: 1 },
//     { field: "city", headerName: "City", flex: 1 },
//     { field: "zipcode", headerName: "Zip Code", flex: 1 },
//     {
//       field: "actions",
//       headerName: "Actions",
//       flex: 1,
//       sortable: false,
//       renderCell: (params) => (
//         <Box>
//           <IconButton onClick={() => handleView(params.row)}>
//             <VisibilityIcon style={{ color: colors.greenAccent[500] }} />
//           </IconButton>
//           <IconButton onClick={() => handleEdit(params.row.id)}>
//             <EditIcon style={{ color: colors.blueAccent[600] }} />
//           </IconButton>
//           <IconButton onClick={() => handleDelete(params.row.registrarid)}>
//             <DeleteIcon style={{ color: colors.redAccent[600] }} />
//           </IconButton>
//         </Box>
//       ),
//     },
//   ];

//   return (
//     <Box m="20px">
//       <Header title="Farmer Management" subtitle="List of Farmers Details" />
//       <Box
//         m="40px 0 0 0"
//         height="75vh"
//         sx={{
//           "& .MuiDataGrid-root": { border: "none" },
//           "& .MuiDataGrid-cell": { borderBottom: "none" },
//           "& .name-column--cell": { color: colors.greenAccent[300] },
//           "& .MuiDataGrid-columnHeaders": {
//             backgroundColor: colors.blueAccent[700],
//             borderBottom: "none",
//           },
//           "& .MuiDataGrid-virtualScroller": { backgroundColor: colors.primary[400] },
//           "& .MuiDataGrid-footerContainer": {
//             borderTop: "none",
//             backgroundColor: colors.blueAccent[700],
//           },
//           "& .MuiCheckbox-root": { color: `${colors.greenAccent[200]} !important` },
//           "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
//             color: `${colors.grey[100]} !important`,
//           },
//         }}
//       >
//         <Box display="flex" justifyContent="flex-end" mb={2}>
//           <Button variant="contained" color="primary" sx={{ marginTop: "20px" }}>
//             Add Farmer
//           </Button>
//         </Box>

//         <DataGrid
//           rows={rows}
//           columns={columns}
//           components={{ Toolbar: GridToolbar }}
//         />

//         <Dialog open={open} onClose={handleClose}>
//           <DialogTitle>Farmer Management</DialogTitle>
//           <DialogContent>
//             {/* Here the data are visibility */}
//             {selectedRow && (
//               <>
//                 <Typography><strong>ID:</strong> {selectedRow.id}</Typography>
//                 <Typography><strong>Registrar ID:</strong> {selectedRow.registrarid}</Typography>
//                 <Typography><strong>Name:</strong> {selectedRow.name}</Typography>
//                 <Typography><strong>Age:</strong> {selectedRow.age}</Typography>
//                 <Typography><strong>Phone:</strong> {selectedRow.phone}</Typography>
//                 <Typography><strong>Email:</strong> {selectedRow.email}</Typography>
//                 <Typography><strong>Address:</strong> {selectedRow.address}</Typography>
//                 <Typography><strong>City:</strong> {selectedRow.city}</Typography>
//                 <Typography><strong>Zip Code:</strong> {selectedRow.zipcode}</Typography>
//               </>
//             )}
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={handleClose} color="primary">Close</Button>
//           </DialogActions>
//         </Dialog>
//       </Box>
//     </Box>
//   );
// };

// export default Contacts;



import { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { useTheme } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";

const Contacts = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [rows, setRows] = useState([]); // State to manage rows data
  const [openView, setOpenView] = useState(false); // State to control the view dialog
  const [openEdit, setOpenEdit] = useState(false); // State to control the edit dialog
  const [selectedRow, setSelectedRow] = useState(null); // State to hold selected row data

  const getTransactionData = async () => {
    try {
      const response = await axios.get('http://localhost:3000/api/contacts');
      console.log(response.data);
      setRows(response.data); // Set the fetched data directly to rows
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getTransactionData();
  }, []);

  // Function to handle row deletion
  const handleDelete = async (registrarId) => {
    try {
      await axios.delete(`http://localhost:3000/api/contacts/${registrarId}`); // DELETE request
      const updatedRows = rows.filter((row) => row.registrarid !== registrarId); // Filter out the row to be deleted
      setRows(updatedRows); // Update the rows state with the filtered data
    } catch (error) {
      console.error("Error deleting data:", error);
    }
  };

  const handleEdit = (row) => {
    setSelectedRow(row); // Set the clicked row data
    setOpenEdit(true); // Open the edit dialog
  };

  // Function to handle view icon click and open popup
  const handleView = (row) => {
    setSelectedRow(row); // Set the clicked row data
    setOpenView(true); // Open the view dialog
  };

  // Function to close the view dialog
  const handleCloseView = () => {
    setOpenView(false);
    setSelectedRow(null);
  };

  // Function to close the edit dialog
  const handleCloseEdit = () => {
    setOpenEdit(false);
    setSelectedRow(null);
  };

  // Function to handle save action in edit dialog
  const handleSaveEdit = async () => {
    try {
      // Assuming you have an API endpoint to update the row data
      await axios.put(`http://localhost:3000/api/contacts/${selectedRow.registrarid}`, selectedRow); // Update request
      const updatedRows = rows.map((row) => (row.registrarid === selectedRow.registrarid ? selectedRow : row));
      setRows(updatedRows);
      handleCloseEdit(); // Close the edit dialog
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 0.5 },
    { field: "registrarid", headerName: "Registrar ID" },
    { field: "name", headerName: "Name", flex: 1, cellClassName: "name-column--cell" },
    { field: "age", headerName: "Age", type: "number", headerAlign: "left", align: "left" },
    { field: "phone", headerName: "Phone Number", flex: 1 },
    { field: "email", headerName: "Email", flex: 1 },
    { field: "address", headerName: "Address", flex: 1 },
    { field: "city", headerName: "City", flex: 1 },
    { field: "zipcode", headerName: "Zip Code", flex: 1 },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <Box>
          <IconButton onClick={() => handleView(params.row)}>
            <VisibilityIcon style={{ color: colors.greenAccent[500] }} />
          </IconButton>
          <IconButton onClick={() => handleEdit(params.row)}>
            <EditIcon style={{ color: colors.blueAccent[600] }} />
          </IconButton>
          <IconButton onClick={() => handleDelete(params.row.registrarid)}>
            <DeleteIcon style={{ color: colors.redAccent[600] }} />
          </IconButton>
        </Box>
      ),
    },
  ];

  return (
    <Box m="20px">
      <Header title="Farmer Management" subtitle="List of Farmers Details" />
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": { border: "none" },
          "& .MuiDataGrid-cell": { borderBottom: "none" },
          "& .name-column--cell": { color: colors.greenAccent[300] },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": { backgroundColor: colors.primary[400] },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": { color: `${colors.greenAccent[200]} !important` },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <Box display="flex" justifyContent="flex-end" mb={2}>
          <Button variant="contained" color="primary" sx={{ marginTop: "20px" }}>
            Add Farmer
          </Button>
        </Box>

        <DataGrid
          rows={rows}
          columns={columns}
          components={{ Toolbar: GridToolbar }}
        />

        {/* View Dialog */}
        <Dialog open={openView} onClose={handleCloseView}>
          <DialogTitle>Farmer Management</DialogTitle>
          <DialogContent>
            {selectedRow && (
              <>
                <Typography><strong>ID:</strong> {selectedRow.id}</Typography>
                <Typography><strong>Registrar ID:</strong> {selectedRow.registrarid}</Typography>
                <Typography><strong>Name:</strong> {selectedRow.name}</Typography>
                <Typography><strong>Age:</strong> {selectedRow.age}</Typography>
                <Typography><strong>Phone:</strong> {selectedRow.phone}</Typography>
                <Typography><strong>Email:</strong> {selectedRow.email}</Typography>
                <Typography><strong>Address:</strong> {selectedRow.address}</Typography>
                <Typography><strong>City:</strong> {selectedRow.city}</Typography>
                <Typography><strong>Zip Code:</strong> {selectedRow.zipcode}</Typography>
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseView} color="primary">Close</Button>
          </DialogActions>
        </Dialog>

        {/* Edit Dialog */}
        <Dialog open={openEdit} onClose={handleCloseEdit}>
          <DialogTitle>Edit Farmer</DialogTitle>
          <DialogContent>
            {selectedRow && (
              <>
                <TextField
                  autoFocus
                  margin="dense"
                  label="Registrar ID"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={selectedRow.registrarid}
                  onChange={(e) => setSelectedRow({ ...selectedRow, registrarid: e.target.value })}
                />
                <TextField
                  margin="dense"
                  label="Name"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={selectedRow.name}
                  onChange={(e) => setSelectedRow({ ...selectedRow, name: e.target.value })}
                />
                <TextField
                  margin="dense"
                  label="Age"
                  type="number"
                  fullWidth
                  variant="outlined"
                  value={selectedRow.age}
                  onChange={(e) => setSelectedRow({ ...selectedRow, age: e.target.value })}
                />
                <TextField
                  margin="dense"
                  label="Phone"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={selectedRow.phone}
                  onChange={(e) => setSelectedRow({ ...selectedRow, phone: e.target.value })}
                />
                <TextField
                  margin="dense"
                  label="Email"
                  type="email"
                  fullWidth
                  variant="outlined"
                  value={selectedRow.email}
                  onChange={(e) => setSelectedRow({ ...selectedRow, email: e.target.value })}
                />
                <TextField
                  margin="dense"
                  label="Address"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={selectedRow.address}
                  onChange={(e) => setSelectedRow({ ...selectedRow, address: e.target.value })}
                />
                <TextField
                  margin="dense"
                  label="City"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={selectedRow.city}
                  onChange={(e) => setSelectedRow({ ...selectedRow, city: e.target.value })}
                />
                <TextField
                  margin="dense"
                  label="Zip Code"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={selectedRow.zipcode}
                  onChange={(e) => setSelectedRow({ ...selectedRow, zipcode: e.target.value })}
                />
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseEdit} color="primary">Cancel</Button>
            <Button onClick={handleSaveEdit} color="primary">Save</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
};

export default Contacts;
